import * as React from 'react'
import PropTypes from 'prop-types'
import Controller from './Controller'

type Props = {|
  anchor: ?any,
  bgColor?: 'transparentBlack' | 'purple',
  children?: any,
  idealDirection?: 'up' | 'right' | 'down' | 'left',
  onDismiss: () => void,
  positionRelativeToAnchor?: boolean,
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number,
|};

export default class ContextFlyout extends React.PureComponent<Props> {
  render() {
    const {
      anchor,
      bgColor = 'transparentBlack',
      children,
      idealDirection,
      positionRelativeToAnchor = true,
      onDismiss,
      size,
      zIndex
    } = this.props

    if (!anchor) {
      return null
    }

    return (
      <Controller
        anchor={anchor}
        bgColor={bgColor}
        idealDirection={idealDirection}
        onDismiss={onDismiss}
        positionRelativeToAnchor={positionRelativeToAnchor}
        shouldFocus
        size={size}
        zIndex={zIndex}
      >
        {children}
      </Controller>
    )
  }
}

ContextFlyout.propTypes = {
  anchor: PropTypes.shape({
    contains: PropTypes.func,
    getBoundingClientRect: PropTypes.func,
  }),
  bgColor: PropTypes.oneOf(['purple', 'transparentBlack']),
  children: PropTypes.node,
  idealDirection: PropTypes.oneOf(['up', 'right', 'down', 'left']),
  onDismiss: PropTypes.func.isRequired,
  positionRelativeToAnchor: PropTypes.bool,
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['xxs','xs', 'sm', 'md', 'lg', 'xl']), // default: sm
  ]),
  zIndex: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/core/components/flyout/ContextFlyout.js